import React, { useEffect } from "react";
import "./Articles.css";
import { useParams } from "react-router-dom";
import currentArticles from "./currentArticles";
import parse from "html-react-parser";
import Crunches from "../Crunches";
import { useLanguage } from "../LanguageContext";
import { getLocalizedArticle } from "../localizedContent";
import { getFallbackImage, replaceWithFallback } from "../imageFallbacks";

function Article() {
  const { language } = useLanguage();
  const { id } = useParams();
  const article = currentArticles.find((element) => element.id === parseInt(id));
  const localizedArticle = getLocalizedArticle(article, language);
  const target = {
    title: localizedArticle.title,
    subcategory: "Artykuly",
    subcategoryLabel: "Artykuły",
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <div className="single-article">
      <Crunches target={target} />
      <div className="single-article-article">
        <img
          className="rounded"
          src={localizedArticle.image || getFallbackImage("place")}
          onError={(event) => replaceWithFallback(event, "place")}
          alt=""
        />
        <div>
          <h3>{localizedArticle.title}</h3>
        </div>
        <div>
          <div className="article-content">{parse(localizedArticle.content)}</div>
        </div>
        <div>
          <p className="article-author">
            {article.date}
            <br />
            {language === "en" ? "author" : "autor"}: {localizedArticle.author}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Article;
